import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import FormDialog from '../../../library/form/components/FormDialog';
import FormRichText from '../../../library/form/components/FormRichText';
import FormInput from '../../../library/form/components/FormInput';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormSH from '../../../library/form/components/FormSH';
import FormCheckbox from '../../../library/form/components/FormCheckbox';
import FormUpload from '../../../library/form/components/FormUpload';
import FormAttachment from '../../../library/form/components/FormAttachment';
import FormLabel from '../../../library/form/components/FormLabel';
import FormTitle from '../../../library/form/components/FormTitle';
import FormWrapper from '../../../library/form/components/FormWrapper';

const DocImageEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ width: '420px', height: '425px' }} formTitle={<FormTitle formObject={formObject} value="Image" />}
        >
            <div id="editornew" >
                <FormWrapper customWrapper="div" wrapperClass="uiSpacer5" formObject={formObject} 
                    rowKey="" action={{ paramName: "imageSelector" }} >
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "imageSelector" }} value="Image" />
                    </span>
                    <FormUpload formObject={formObject} rowKey="" 
                    action={{ actionId:"upload", paramName: "imageSelector", actionName: "mediaManage", actionParam: {"rt":"i"} }} />
                </FormWrapper>
                <FormWrapper customWrapper="div" wrapperClass="uiSpacer5" formObject={formObject} 
                    rowKey="" action={{ paramName: "imageLink" }} >
                    <FormAttachment formObject={formObject} rowKey="" action={{ InputType: "i", paramName: "imageLink"}} />
                </FormWrapper>
                <div className="uiSpacer5">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docType" }} value="Type" />
                    </span>
                    <FormInput formObject={formObject} rowKey="" className="uiInput uiSpacerH5"
                        action={{ InputType: "ac", paramName: "docType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                    />
                    <FormSH formObject={formObject} rowKey="" 
                        action={{ actionId: "new", paramName: "docType",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                    />
                </div>
                <div className="uiSpacer5">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "desc" }} value="Remarks" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" id="delInstTxt" className="uiFrmText" rows="3" cols="82"
                        action={{ paramName: "desc" }}
                    />
                </div>
                <div className="uiSpacer5">
                    <span className="uiLblInLine">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isDefault" }} value="Set Default" />
                    </span>
                    <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "isDefault" }} />
                    <span className="uiLblInLine">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "showOnApp" }} value="Show on App?" />
                    </span>
                    <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "showOnApp" }} />
                    <span className="uiLblInLine">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sortNo" }} value="Sort No" />
                    </span>
                    <FormROValue formObject={formObject} className="uiBlue" rowKey="" action={{ paramName: "sortNo" }} />
                </div>
            </div>
        </FormDialog>

    )
}

export default withView(DocImageEditor, "docImage", "docImage")